import { Box, Link, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { makeStyles } from 'tss-react/mui';

import moment from 'moment';
import config from '@app/configs/config';

import { StatusInfo } from '@features/workspace/components/shared/status-info';

const useStyles = makeStyles<any>()({
  active: {
    color: '#1AAE4E',
  },

  card: {
    border: '1px solid #CCCCCC',
    minHeight: '130px',
    borderRadius: '20px',
  },

  container: {
    margin: '0 0 0 0 !important',
  },

  centerAligned: {
    alignItems: 'center',
    alignContent: 'center',
    textAlign: 'center',
  },

  rightAligned: {
    textAlign: 'right',
  },
});

type ProductInfoStatusProps = {
  header: string;
  headerLink?: string | null;
  statusMessage?: string | null | undefined;
  activeStatus: boolean | null;
  productApplicationDate?: string | null | undefined;
  showIcon?: boolean | null;
};

export function ProductInfoStatus({
  header,
  headerLink,
  statusMessage,
  activeStatus,
  productApplicationDate,
  showIcon,
}: ProductInfoStatusProps) {
  const { classes } = useStyles(null);

  const statusText: string | null | undefined =
    statusMessage || (activeStatus ? 'Active' : 'Not active');

  const offlineIcon: any = statusMessage ? (
    <i className="ri-time-line" style={{ fontSize: 25, color: '#519AB9' }} />
  ) : (
    <i
      className="ri-cloud-off-line"
      style={{ fontSize: 25, color: '#838383' }}
    />
  );
  const productIcon: any = activeStatus ? (
    <CheckCircleOutlineIcon className={classes.active} height={24} />
  ) : (
    offlineIcon
  );
  const productDate = productApplicationDate ? (
    moment(productApplicationDate).format(config.dateFormat)
  ) : (
    <>&nbsp;</>
  );

  return (
    <Box className={classes.card} display="flex" flexDirection="column" p={1}>
      <Box display="flex">
        <Box display="flex" flexGrow={1}>
          <>
            {headerLink && (
              <Link href={headerLink} target="LulaCustomerDetails">
                {header}
              </Link>
            )}
            {!headerLink && { header }}
          </>
        </Box>
        <Box display="flex" textAlign="right">
          {productIcon}
        </Box>
      </Box>
      <Box display="flex" justifyContent="center" mt={2}>
        <StatusInfo
          isCompleted={activeStatus ?? false}
          showIcon={showIcon ?? false}
          showWithoutColour={!statusMessage}
          text={statusText}
        />
      </Box>
      <Box display="flex" justifyContent="center" mt={1}>
        <Typography variant="body1">{productDate}</Typography>
      </Box>
    </Box>
  );
}
